import { render, staticRenderFns } from "./MyItems.vue?vue&type=template&id=56499b13"
import script from "./MyItems.vue?vue&type=script&lang=js"
export * from "./MyItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports